/* eslint-disable new-parens */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { PrimaryDrawer } from "../Drawer/PrimaryDrawer";
import {
    Button, TextField, Box, Typography, RadioGroup,
    FormControl, FormControlLabel, Radio, Checkbox
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { SelectedIcon, UnSelectedIcon } from "../../components/Icons/selectedIcon";
import clsx from 'clsx';
import { capitalizeFirstLetter } from "../../../../helpers/utilities";
import { dataTypeConstant } from "../../../../config/constant";
import customStyles from "../../../../assets/styles/customStyles";
import { Row, Col, Image, Space } from "antd";
import { AutoCompleteComponent } from "../AutoCompleteComponent";
import SearchIcon from "../../../../assets/images/icon_actions/Search Icon.svg";
import crudActions from "../../../../layouts/CRUD/redux/actions";
import usePrevious from "../Previous";
import CustomAlert from "../CustomAlert";
import { exportCommonFile } from "../../../../helpers/utilities";
import moment from 'moment';

var XLSX = require("xlsx");

export const ImportExport = React.forwardRef((props, ref) => {
    const { visible, type, title, handleClose, loadTasks, loader, loadImportExportData } = props;
    const { importDetails, importError, importLoader } = useSelector(state => state.crudReducer);
    const fileInput = useRef();
    const [dataType, setDataType] = useState(dataTypeConstant);
    const [dataTypeSkip, setDataTypeSkip] = useState([]);

    const [form, setForm] = useState({
        dataType: title,
        importType: "insert",
        fileFormat: "xlsx",
        column: "required_fields"
    });

    const [error, setError] = useState({});
    const [successMessage, setSuccessMessage] = useState(false);
    const [data, setData] = useState([]);
    const [filePath, setFilePath] = useState('');
    const [selected, setSelected] = useState([]);
    const prevImportDetails = usePrevious(importDetails);
    const prevImportError = usePrevious(importError);
    const dispatch = useDispatch();

    useEffect(() => {
        setDataType(dataTypeConstant);
        requiredFields(true);
    }, [form.dataType]);

    const requiredFields = (required) => {
        let newHead = [];
        let heads = [];

        const index = dataType.findIndex(el => { return el.id === form.dataType });
        if (dataTypeSkip?.length > 0) {
            dataType[index]['fieldList'] = dataTypeSkip;
        }
        const a = dataType.filter(el => { return el.id === form.dataType });

        if (a && a.length !== 0) {
            heads = a[0].fieldList;
        }
        if (required) {
            heads && heads?.length > 0 && heads?.map((h, k) => {
                if (h.required) {
                    newHead.push(h.key);
                }
            });
        } else {
            heads?.length > 0 && heads?.map((h, k) => {
                newHead.push(h.key);
            });
        }
        setSelected(newHead);
    }

    const handleImportClose = () => {
        setError([]);
        setData([]);
        setFilePath('');
        setForm({
            dataType: title,
            importType: "insert",
            fileFormat: "xlsx",
            column: "required_fields"
        });
        requiredFields(true);
        fileInput.current.value = '';
    }

    const handleImportAllClose = () => {
        handleImportClose();
        setSuccessMessage(false);
        handleClose();
    }

    const importProcess = (e) => {
        e.preventDefault();
        let heads = []; let error = [];
        //let number = ''; let coloumDuplicateCheck = false; let duplicate = ''; 
        let api = '';
        const a = dataType.filter(el => { return el.id === form?.dataType });
        if (a && a.length !== 0) {
            heads = a[0]?.fieldList;
            //duplicate = a[0]?.duplicate;
            api = a[0].api;
            // coloumDuplicateCheck = a[0]?.coloumDuplicateCheck;
        }

        let newArray = [];
        if (data && data?.length === 0) {
            error.push(`Please upload file having extensions ${form.fileFormat} only.`);
        } else {
            // let unique = duplicate !== undefined ? data.filter((set => f => !set.has(f[duplicate]) && set.add(f[duplicate]))(new Set)) : [];
            // let difference = [];
            // if (coloumDuplicateCheck) {
            //     difference = duplicate !== undefined ? data.filter(x => !unique.includes(x)) : [];
            // }
            // if (difference.length === 0) {
            data?.map((d, i) => {
                let newHead = [];
                heads?.filter((el) => !el.importSkip)?.map((h, k) => {
                    if (selected.find(e => e === h.key)) {
                        if (h.limit && h.limit < d[h.key].length) {
                            error.push(`Row ${parseInt(d.__rowNum__) + 1} column ${h.key} allowed only ${h.limit} characters.`);
                            fileInput.current.value = '';
                        } else if (h.emptyCheck && (d[h.key] === 'blank' || d[h.key] === '')) {
                            error.push(`Row ${parseInt(d.__rowNum__) + 1} ${h.key} column - Blank values not allowed.`);
                        } else {
                            if (d[h.key] !== undefined) {
                                if (d[h.key] === 'blank' || d[h.key] === '') {
                                    if (h.type === 'integer') {
                                        newHead[h.apiField] = null;
                                    } else if (h.type === 'boolean') {
                                        newHead[h.apiField] = false;
                                    } else {
                                        newHead[h.apiField] = 'blank';
                                    }
                                } else {
                                    if (h.type === 'date') {
                                        newHead[h.apiField] = d[h.key][0] ? moment(d[h.key]).format('YYYY-MM-DD') : moment(d[h.key]).add(1, 'days').format('YYYY-MM-DD');
                                    } else {
                                        newHead[h.apiField] = d[h.key];
                                    }
                                }
                            } else {
                                if (h.type === 'integer' || h.type === 'date') {
                                    newHead[h.apiField] = null;
                                } else if (h.type === 'boolean') {
                                    newHead[h.apiField] = false;
                                } else {
                                    newHead[h.apiField] = null;
                                }
                            }
                        }
                    } else {
                        if (h.type === 'integer' || h.type === 'date') {
                            newHead[h.apiField] = null;
                        } else if (h.type === 'boolean') {
                            newHead[h.apiField] = false;
                        } else {
                            newHead[h.apiField] = null;
                        }
                    }
                });

                newArray.push(Object.assign({}, newHead));
            });
            // } 
            // else {
            //     difference.length > 0 && difference.map((diff, i) => {
            //         number += `${parseInt(diff.__rowNum__) + 1},`;
            //     });
            //     if (difference.length === 1) {
            //         error.push(`Row ${number.replace(/,\s*$/, "")} is duplicate`);
            //     } else {
            //         error.push(`Rows ${number.replace(/,\s*$/, "")} are duplicate`);
            //     }
            // }
        } 

        if (error && Array?.isArray(error) && error?.length > 0) {
            setSuccessMessage(false);
            setError({
                uploadFile: error.join("<br />")
            });
        } else {
            dispatch({
                type: crudActions.IMPORT_START,
                url: form.importType === 'insert' ? `${api}/bulk` : `${api}/updatebulk`,
                title: form.dataType,
                importType: form.importType,
                details: newArray
            });
        }
        fileInput.current.value = '';
    }

    useEffect(() => {
        if (prevImportDetails !== undefined && importDetails && prevImportDetails !== importDetails) {
            loadTasks();
            let message = `${importDetails?.length} ${importDetails?.length > 1 ? 'Rows' : 'Row'} ${form.importType === 'insert' ? 'Created' : 'Updated'} Successfully`;
            setSuccessMessage(importDetails?.message ? importDetails?.message : message);
            handleImportClose();
        } else if (prevImportError !== undefined && importError && prevImportError !== importError) {
            let error = importError.error.message;
            setError({ uploadFile: error });
            setSuccessMessage(false);
        }
    }, [importDetails, importError]);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleFile = (e) => {
        const files = e.target.files;
        var filePath = e.target.value;
        let duplicate = '';
        const a = dataType.filter(el => { return el.id === form.dataType });
        if (a && a?.length !== 0) {
            duplicate = a[0]?.duplicate;
        }

        if (files && files?.length) {
            const file = files[0];
            var allowedExtensions = '';
            if (form.fileFormat === 'xlsx') {
                allowedExtensions = /(\.xlsx|\.xls)$/i;
            } else if (form.fileFormat === 'csv') {
                allowedExtensions = /(\.csv)$/i;
            }

            if (!allowedExtensions.exec(filePath)) {
                setFilePath('');
                setError({ "uploadFile": `Please upload file having extensions ${form.fileFormat} only.` });
            } else {
                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
                reader.onload = (e) => {
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array", cellDates: true });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const dataResult = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    const result = XLSX.utils.sheet_to_json(ws, { defval: 'blank', raw: true, dateNF: 'yyyy^mmm^dd' });
                    if (duplicate && dataResult[0][0] !== duplicate) {
                        setData([]);
                        setFilePath('');
                        setError({ "uploadFile": `Invalid data format, file not uploaded. Please check the template and upload data again` });
                    } else {
                        setData(result);
                        setError({ "uploadFile": '' });
                        setFilePath(filePath);
                    }
                };
                if (rABS) {
                    reader.readAsBinaryString(file);
                } else {
                    reader.readAsArrayBuffer(file);
                }
            }
        }
    }

    const exportFile = (type) => {
        if (type === 'existing') {
            loadImportExportData(form.dataType, type, selected, form.fileFormat, 'import');
        } else {
            exportCommonFile(form.dataType, [], type, selected, form.fileFormat);
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'importType') {
                const a = dataType.filter(el => { return el.id === form.dataType });
                var index = dataType.findIndex(el => { return el.id === form.dataType });
                setDataTypeSkip(a[0]?.fieldList);
                if (e === 'update') {
                    dataType[index]['fieldList'] = a[0]?.fieldList.filter(details => !details.skip);
                } else {
                    if (dataTypeSkip?.length > 0) {
                        dataType[index]['fieldList'] = dataTypeSkip;
                    }
                }
                setDataType(dataType);
                setForm({
                    ...form,
                    [name]: e,
                });
            } else if (name === 'dataType') {
                setForm({
                    ...form,
                    'column': 'required_fields',
                    [name]: e,
                });
            }

        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }

    }

    const handleChange = (e) => {
        const selectedIndex = selected.indexOf(e.target.value);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, e.target.value);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    }

    const handleDataColumn = (e) => {
        let v = e.target.value;
        if (v === 'required_fields') {
            requiredFields(true);
        } else {
            requiredFields(false);
        }
        changeHandler(e);
    }

    const handleUnSelectedAll = () => {
        requiredFields(true);
    }

    const classes = customStyles();
    return <PrimaryDrawer
        anchor={'right'}
        open={visible}
        variant={'temporary'}
        handleClose={() => handleImportAllClose()}
        title={`${capitalizeFirstLetter(type)} ${form.dataType}`}
        width={"800px"}
        className={clsx(classes.closeBackGround, classes.width100PImport)}
        component={
            <>
                {
                    type === 'import' ? (
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderlineImport)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => importProcess(e)}
                        >
                            <div className={clsx(classes.customFormFlex)}>

                                <Row gutter={50}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Row>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Data Type  Selection</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.margin10t)}>Data Type</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{customObject(dataType, form.dataType)?.name}</Typography>
                                                <AutoCompleteComponent
                                                    name={["Import Type"]}
                                                    heads={[{ 'key': 'name', 'name': 'Import Type' }]}
                                                    details={[{ id: "insert", name: "Insert Only New Records, Do not Update" }, { id: "update", name: "Update existing data" }]}
                                                    parentValue={customObject([
                                                        { id: "insert", name: "Insert Only New Records, Do not Update" },
                                                        { id: "update", name: "Update existing data" }], form.importType)}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                    onChange={(data) => changeHandler(data.id, 'importType')}
                                                />
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.margin20t)}>Options for Download</Typography>
                                                <AutoCompleteComponent
                                                    name={["File Format"]}
                                                    heads={[{ 'key': 'name', 'name': 'Data Type' }]}
                                                    details={[
                                                        { id: "xlsx", name: "Microsoft Excel (xls)" },
                                                        { id: "csv", name: "CSV" },
                                                        { id: "sheets", name: "Google Sheet" },
                                                    ]}
                                                    parentValue={customObject([
                                                        { id: "xlsx", name: "Microsoft Excel (xls)" },
                                                        { id: "csv", name: "CSV" },
                                                        { id: "sheets", name: "Google Sheet" },
                                                    ], form.fileFormat)}
                                                    position={"bottom"}
                                                    customClasses={classes.margin10t}
                                                    onChange={(data) => changeHandler(data.id, 'fileFormat')}
                                                />
                                                <Button
                                                    key="blank"
                                                    color="primary"
                                                    variant="contained"
                                                    className={clsx(classes.AddMoreBtn, classes.padding10, classes.margin35t, classes.Width100Per)}
                                                    onClick={() => exportFile('blank')}
                                                >Download Blank Template</Button>
                                                <Button
                                                    key="existing"
                                                    color="primary"
                                                    variant="contained"
                                                    className={clsx(classes.AddMoreBtn, classes.padding10, classes.margin35t, classes.Width100Per, { [classes.loading]: loader })}
                                                    onClick={() => exportFile('existing')}
                                                >Download With Existing Data</Button>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.margin35t)}>Import</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Browse File</Typography>
                                                <div className={clsx(classes.searchAnimation, classes.iconAnimation, classes.margin10t, classes.Width100Per)}>
                                                    <TextField autoComplete='one-time-code'
                                                        placeholder='Search'
                                                        disabled
                                                        value={filePath}
                                                        className={clsx(classes.browseFile)}
                                                        variant={'standard'}
                                                        fullWidth
                                                    />
                                                    <Image
                                                        src={SearchIcon}
                                                        preview={false}
                                                        onClick={() => fileInput.current.click()}
                                                    />
                                                    <input
                                                        ref={fileInput}
                                                        type="file"
                                                        onChange={(e) => handleFile(e)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                                <div className={clsx(classes.btnParent)}>
                                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                                        <Button
                                                            key="attach"
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={() => fileInput.current.click()}
                                                            className={clsx(classes.AddMoreBtn)}
                                                        >Attach File
                                                        </Button>
                                                        <Button
                                                            key="upload"
                                                            color="primary"
                                                            variant="contained"
                                                            type="submit"
                                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: importLoader })}
                                                        >Upload File
                                                        </Button>
                                                    </Space>
                                                </div>
                                            </Col>
                                        </Row>


                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Row>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.importExport}>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Data Column Selection</Typography>
                                                <FormControl
                                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.margin10t)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <RadioGroup
                                                        row
                                                        defaultValue="active"
                                                        aria-labelledby="demo-customized-radios"
                                                        name="column"
                                                        value={form.column}
                                                        onChange={(e) => handleDataColumn(e)}>
                                                        <FormControlLabel className={classes.formControlLabel} value="required_fields" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Required Fields" />
                                                        <FormControlLabel className={classes.formControlLabel} value="all_selected_fields" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="All Selected Fields" />

                                                    </RadioGroup>
                                                </FormControl>
                                                {
                                                    title === 'Customer Sales Price' && <AutoCompleteComponent
                                                        name={["Dynamic Price"]}
                                                        heads={[{ 'key': 'name', 'name': 'Dynamic Price' }]}
                                                        details={[{ id: "Customer Sales Price", name: "Sales Price" },
                                                        { id: "Customer Margin Price", name: "Margin" },
                                                        { id: "Customer Purch Price Markup", name: "Purch Price Markup" }, { name: "Sales Price by-Disc on MRP", id: "Customer Discount Price" }]}
                                                        parentValue={customObject([{ id: "Customer Sales Price", name: "Sales Price" },
                                                        { id: "Customer Margin Price", name: "Margin" },
                                                        { id: "Customer Purch Price Markup", name: "Purch Price Markup" },
                                                        { name: "Sales Price by-Disc on MRP", id: "Customer Discount Price" }], form.dataType)}
                                                        position={"bottom"}
                                                        customClasses={classes.margin20t}
                                                        onChange={(data) => changeHandler(data.id, 'dataType')}
                                                    />
                                                }
                                                <div
                                                    className={clsx(classes.boxBorder, classes.boxBorderImport, classes.margin20t, classes.padding20, classes.fieldList)}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.boxBorderTitle, classes.fonSize13)}>Field List
                                                        <Button
                                                            key="upload"
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={() => handleUnSelectedAll()}
                                                            className={clsx(classes.unSelectedButton, { [classes.disabled]: form.column === 'required_fields' })}
                                                        >Un-Select all
                                                        </Button>
                                                    </Typography>
                                                    <div className={classes.importListFields}>
                                                        {
                                                            dataType.filter(dataType => dataType.id === form?.dataType).map((type, i) => (
                                                                <React.Fragment key={i}>
                                                                    {
                                                                        type.fieldList.filter((el) => { return !el.skip }).map((list, i) => (
                                                                            <FormControlLabel key={i}
                                                                                className={clsx(classes.formControlLabel)}
                                                                                value={list.key}
                                                                                control={<Checkbox
                                                                                    checked={selected.indexOf(list.key) !== -1 ? true : false}
                                                                                    onChange={(e) => !list?.required && handleChange(e)}
                                                                                />}
                                                                                label={list.key}
                                                                                labelPlacement="end"
                                                                            />
                                                                        ))
                                                                    }
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>


                                    </Col>
                                </Row>
                                <Row gutter={50}>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        {
                                            (error?.uploadFile || successMessage) &&
                                            <>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.margin30t)}>Logs</Typography>
                                                {
                                                    error?.uploadFile && <CustomAlert error={error?.uploadFile} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                                }
                                                {
                                                    successMessage && <CustomAlert success={successMessage} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                                }
                                            </>
                                        }
                                    </Col>

                                </Row>
                            </div>

                        </Box>
                    ) : (
                        <>
                        </>
                    )
                }
            </>

        }
    />
});